import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import Spinner from "components/common/Spinner"
import GuestHeader from "layoutsV2/client/GuestHeader"
import { useTitle } from "hooks/useTitle"
import { useDispatch, useSelector } from "react-redux"
import { cleanBooking, getPublicBooking } from "store/bookings"
import { cleanTrip, receivedTrip } from "store/trips"
import { TripsPreview } from "components/trips/TripsPreview"

export default function PublicBookingPage() {
  const params = useParams()
  const dispatch = useDispatch()
  const { booking } = useSelector((store) => store.bookings)
  const { trip, loading } = booking

  useTitle(trip?.title)

  useEffect(() => {
    dispatch(getPublicBooking(params.uuid)).then(({ trip }) => dispatch(receivedTrip(trip)))
    return () => dispatch(cleanBooking()) && dispatch(cleanTrip())
  }, [params.uuid]) //eslint-disable-line

  if (loading) return <Spinner />

  return (
    <main className="vstack min-vh-100 bg-light">
      <GuestHeader hideUserControls />
      <div className="flex-fill vstack min-h-100 py-15 px-80">
        {booking.id && <TripsPreview isPublic />}
      </div>
    </main>
  )
}
